import React, {useState, useEffect} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './AddressComponent.metadata.json5';
import messages from './AddressComponent.messages';
import styles from './AddressComponent.module.scss';
import { PitneyBowesService } from './../../../capabilities/nexus-capability-common';

function AddressComponent(props) {
    const { model, onValueChange, hideFields = [], readOnlyFields = [], requiredFields = [], onChangeAddress } = props;
    const [pitneyBowesInstanceKey, setPitneyBowesInstanceKey] = useState();
    const [selectedAddressLineValue, updateAddressLineValue] = useState('');
    const [availableAddresses, setAvailableAddresses] = useState('');
    const [addressOverrideValue, setAddressOverrideValue] = useState('');
    const fields = [
        'override',
        'addressLine1',
        'addressLine2',
        'addressLine3',
        'city',
        'state',
        'country',
        'postalCode',
        'addressType'
     ]
     const [overrideAddress, setOverrideAddress] = useState(false);

    useEffect(() => {
        PitneyBowesService.createAddressingInstanceKey().then(data => {
            setPitneyBowesInstanceKey(data);
        });
    }, []);

    const handleValueAddressLookup = (value) => {
        if (value) {
            let address = availableAddresses[value.id];
            _.set(model.value, 'addressLine1', address.AddressLine1);
            _.set(model.value, 'addressLine2', address.AddressLine2);
            _.set(model.value, 'addressLine3', address.AddressLine3);
            _.set(model.value, 'city', address.City);
            _.set(model.value, 'postalCode', address.PostalCode);
            _.set(model.value, 'state', address.StateProvince);
            //updateWizardData(claimVM);
            if (onChangeAddress) {
                onChangeAddress(model.value);
            }
        }
        updateAddressLineValue(value);
    };

    async function  getAddressesFromTheApi(textInput) {
        let dataArray = [];
        if (textInput === undefined || textInput.length < 9)
            return dataArray;
        if (textInput.length > 12 && availableAddresses.length > 0)
            return availableAddresses;
        let response = await PitneyBowesService.globalTypeAheadCANRequest(pitneyBowesInstanceKey, textInput);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        let responseJson = await response.json();
        let data = responseJson.Output;
        if (data) {
            let originalAddresses = [];
            data.forEach((address, index) => {
                dataArray = [...dataArray, {id: index, displayName: `${address.AddressLine1}, ${address.City}, ${address.StateProvince}`, value: address.AddressLine1}];
                //dataArray = [...dataArray, `${address.AddressLine1.toLowerCase()}, ${address.City.toLowerCase()}, ${address.StateProvince.toLowerCase()}`];
                originalAddresses[index] = address;
            });
            setAvailableAddresses(originalAddresses);
        }
        return dataArray;
    }

    const onAddressChange = (value, path) => {
        if ('postalCode' === path && value) {
            value = value.toUpperCase();
        }
        onValueChange(value, path);
    }

    const generateOverrides = () => {
        const overrides = fields.map((field) => {
            return {
                [`addressLookup${field}`]: {
                    visible: hideFields.indexOf(field) == -1,
                    readOnly: readOnlyFields.indexOf(field) != -1,
                    required: requiredFields.indexOf(field) != -1
                }
            };
        });
        return Object.assign({}, ...overrides);
    }

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            onValueChange: onAddressChange,
            showRequired: true
        },
        /*addressLookUpoverride:{
            value: overrideAddress,
            onValueChange: () => { setOverrideAddress(!overrideAddress) }
        },*/
        addressLookup: {
            //visible: !overrideAddress,
            value: selectedAddressLineValue
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            getAddressesFromTheApi,
            handleValueAddressLookup
        },
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={model}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}
AddressComponent.propTypes = {
    onChangeAddress: PropTypes.func
};
AddressComponent.defaultProps = {
    onChangeAddress: undefined
};
export default AddressComponent
